import { useForm } from '@conform-to/react'
import { parseWithZod } from '@conform-to/zod'
import { useFetcher } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'
import {
	NEWSLETTER_FORM,
	newsletterSchema,
} from '#app/components/forms/newsletter-form/newsletter-form.tsx'
import { NEWSLETTER_I18NEXT } from '#app/routes/($lang).newsletter/route-config'
import { ROOT_INPUTS } from '#app/routes/_layout/route-config.ts'

function useNewsletterForm() {
	const isHydrated = useHydrated()
	const { t } = useTranslation(NEWSLETTER_I18NEXT.routeNewsletter)

	const fetcherKey = NEWSLETTER_FORM.fetcherKey
	const fetcher = useFetcher({ key: fetcherKey })

	const formValues = {
		[ROOT_INPUTS.subaction]: NEWSLETTER_FORM.subaction,
		[ROOT_INPUTS.noJs]: String(!isHydrated),
	}
	const [form, fields] = useForm({
		onValidate({ formData }) {
			return parseWithZod(formData, { schema: newsletterSchema })
		},
		shouldValidate: 'onSubmit',
	})

	return {
		newsletterFetcherKey: fetcherKey,
		newsletterFetcher: fetcher,
		newsletterFormValues: formValues,
		newsletterForm: form,
		newsletterFields: fields,
		t,
	}
}

export { useNewsletterForm }
